import { lazyWithPreload } from '../utils/lazy-with-preload';

export const LoginPage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-login" */ '@app/login/page'),
);

export const ProfilePage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-profile" */ '@app/profile/page'),
);

export const HomePage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-home" */ '@app/home/page'),
);

export const QRCodePage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-qrcode" */ '@app/qrcode/page'),
);

export const ListCreatePage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-list-create" */ '@app/list/new/page'),
);

export const ListDetailPage = lazyWithPreload(
  () =>
    import(/* webpackChunkName: "page-list-detail" */ '@app/list/[:id]/page'),
);

export const ListPurchasePage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-list-purchase" */ '@app/list/[:id]/purchase/page'
    ),
);

export const InvoicesPage = lazyWithPreload(
  () => import(/* webpackChunkName: "page-invoices" */ '@app/invoices/page'),
);

export const InvoiceDetailPage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-invoice-detail" */ '@app/invoice-detail/page'
    ),
);

export const InvoiceItemPage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-invoice-item" */ '@app/invoice-item/page'
    ),
);

export const ItemCatalogPage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-item-catalog" */ '@app/item-catalog/page'
    ),
);

export const ItemCatalogDetailPage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-item-catalog-detail" */ '@app/item-catalog/[:id]/page'
    ),
);

export const ItemCatalogCreatePage = lazyWithPreload(
  () =>
    import(
      /* webpackChunkName: "page-item-catalog-create" */ '@app/item-catalog/new/page'
    ),
);
